(function () {
  'use strict';
  if (window.__spQA == null) window.__spQA = (function () { var q = /[?&]sp_qa=([01])(?:&|$)/.exec(location.search), s = false; try { if (q) localStorage.setItem('sp_qa', q[1]); s = localStorage.getItem('sp_qa') === '1'; } catch (e) {} var r = window.Shopify && window.Shopify.theme && window.Shopify.theme.role; return s || /^(localhost|127\.0\.0\.1)$/.test(location.hostname) || /SimplePaperQA/.test(navigator.userAgent) || (!!r && r !== 'main'); })();
  if (window.__spFeedTracking) return;
  window.__spFeedTracking = true;

  var queue = [];
  var consent = null;

  function allowed() {
    try {
      var api = window.Shopify && window.Shopify.customerPrivacy;
      if (!api || typeof api.analyticsProcessingAllowed !== 'function') return null;
      return !!api.analyticsProcessingAllowed();
    } catch (e) { return null; }
  }
  function deliver(name, props) {
    if (window.__spQA) return;
    try { if (window.posthog && typeof window.posthog.capture === 'function') window.posthog.capture(name, props); } catch (e) {}
    try { if (typeof window.gtag === 'function') window.gtag('event', name, props); } catch (e) {}
  }
  function send(name, props) {
    if (consent === true) { deliver(name, props); return; }
    if (consent === false) return;
    if (queue.length < 40) queue.push([name, props]);
  }
  function settle() {
    var a = allowed();
    if (a === null) return;
    consent = a;
    if (a) queue.forEach(function (q) { deliver(q[0], q[1]); });
    queue.length = 0;
  }
  settle();
  document.addEventListener('visitorConsentCollected', settle);
  window.setTimeout(settle, 1200);
  window.setTimeout(function () { if (consent === null) { consent = false; queue.length = 0; } }, 8000);

  function rowOf(el) {
    var row = el && el.closest && el.closest('.collection-slider-row, .shopify-section');
    return row && row.querySelector('.sp-feed-ctrl') ? row : null;
  }
  function feedOf(row) {
    var on = row.querySelector('[data-sp-feed][aria-checked="true"]');
    if (on) return on.getAttribute('data-sp-feed');
    var t = row.querySelector('[data-sp-feed-toggle]');
    return t && t.getAttribute('aria-pressed') === 'true' ? 'top' : 'newest';
  }
  function handleOf(href) {
    var m = (href || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]).slice(0, 80) : 'unknown';
  }

  document.addEventListener('click', function (ev) {
    var t = ev.target;
    if (!t || !t.closest) return;
    var row = rowOf(t);
    if (!row) return;
    var from = feedOf(row);

    var summary = t.closest('[data-sp-feed-menu] > summary');
    if (summary) {
      // left the state it came from on the menu.
      var menuEl = summary.parentNode;
      if (!menuEl.querySelector('.sp-feed-menu__panel')) {
        var was = menuEl.getAttribute('data-sp-feed-from') || 'newest';
        send('sp_feed_select', { feed: was === 'newest' ? 'top' : 'newest', from: was });
        return;
      }
      // <details> toggles after the click; a closed menu here is about to open.
      if (!summary.parentNode.hasAttribute('open')) send('sp_feed_menu_open', { feed: from });
      return;
    }
    var opt = t.closest('[data-sp-feed]');
    if (opt) {
      var to = opt.getAttribute('data-sp-feed');
      if (to !== from) send('sp_feed_select', { feed: to, from: from });
      return;
    }
    if (t.closest('[data-sp-feed-toggle]')) {
      send('sp_feed_select', { feed: from === 'newest' ? 'top' : 'newest', from: from });
      return;
    }
    if (t.closest('.quickbuy-toggle, .quickbuy-container')) return;
    var a = t.closest('a[href*="/products/"]');
    if (a && a.closest('.product-grid, .slider__grid')) send('sp_feed_product_click', { feed: from, product: handleOf(a.getAttribute('href')) });
  }, true);

  // The popover's switches (2026-10-02): a "Popular" switch replaced the Newest / Popular options, so a sort
  // change arrives as a change event; capture phase runs before sp-feed-switch.js updates the row, so
  // feedOf() still reads the state being left. "By category" on/off is sp_feed_group.
  document.addEventListener('change', function (ev) {
    var t = ev.target;
    if (!t || !t.matches) return;
    var row = rowOf(t);
    if (!row) return;
    if (t.matches('[data-sp-feed-popular]')) {
      var from = feedOf(row), to = t.checked ? 'top' : 'newest';
      if (to !== from) send('sp_feed_select', { feed: to, from: from });
    } else if (t.matches('[data-sp-feed-group]')) {
      send('sp_feed_group', { on: t.checked ? 'yes' : 'no' });
    } else if (t.matches('[data-sp-feed-similar]')) {
      send('sp_feed_similar', { on: t.checked ? 'yes' : 'no', feed: feedOf(row) });
    }
  }, true);

  function watchSeen() {
    document.querySelectorAll('.sp-feed-ctrl').forEach(function (ctrl) {
      var row = rowOf(ctrl);
      if (!row || row.__spFeedSeen) return;
      row.__spFeedSeen = true;
      if (!('IntersectionObserver' in window)) { send('sp_feed_seen', { feed: feedOf(row) }); return; }
      var io = new IntersectionObserver(function (entries) {
        if (entries.some(function (e) { return e.isIntersecting; })) {
          io.disconnect();
          send('sp_feed_seen', { feed: feedOf(row) });
        }
      }, { threshold: 0.4 });
      io.observe(row);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watchSeen); else watchSeen();
  document.addEventListener('shopify:section:load', watchSeen);
})();
